import { defineMessages } from 'react-intl';

export default defineMessages({
    billingSummaryTabs: {
        id: 'billing.billing-summary-page.Billing Summary',
        defaultMessage: 'Billing Summary'
    },
    failedToLoadPolices: {
        id: 'billing.billing-summary.Failed to load polices',
        defaultMessage: 'Failed to load polices'
    },
    sorryWeCanNotLoadYourPolicyInformationAtThisTime: {
        id: 'billing.billing-summary.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    noBillingData: {
        id: 'billing.billing-summary.No Billing Data Available at this time',
        defaultMessage: 'No Billing Data Available at this time'
    }
});
